
import type { ServiceDocument } from '@mimir/common/dto/ServiceDocumentDtos';
import type { BackendClient } from '@mimir/common/util/backendClient';
import { assert } from '@mimir/common/util/invariant';
import type { QuashableApiClient } from '@mimir/common/util/quashableHttp';

let globalServiceDocument: ServiceDocument | null = null;
let globalApiClient: QuashableApiClient | null = null;

export function setGlobalServiceDocument(serviceDoc: ServiceDocument) {
  globalServiceDocument = serviceDoc;
}

export function getGlobalServiceDocument(): ServiceDocument {
  assert(globalServiceDocument != null, 'Initialization of global backend client must be performed before use.');
  return globalServiceDocument;
}

export function hasGlobalServiceDocument(): boolean {
  return globalServiceDocument != null;
}

export function setGlobalApiClient(apiClient: QuashableApiClient) {
  globalApiClient = apiClient;
}

export function getGlobalApiClient(): QuashableApiClient {
  assert(globalApiClient != null, 'Initialization of global backend client must be performed before use.');
  return globalApiClient;
}

export const globalBackendClient: BackendClient = {
  getApiClient: () => getGlobalApiClient(),
  getServiceLinks: () => getGlobalServiceDocument().links,
};
